import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import type { ImmutableTrip } from 'src/types/trips/Trips';
import { open } from 'src/common/ducks/zippy';
import UnstyledButton from 'src/common/components/UnstyledButton';
import { FORMS } from 'src/inbox/constants';
import useOfferErrors from 'src/inbox/hooks/useOfferErrors';
import CaptainModal from '../cards/Captain/modal';
import TimeModal from '../cards/Time/modal';
import { CTAError } from '../CTA';

type OfferErrorProps = {
  trip: ImmutableTrip;
};

/**
 * Displayed above CTA buttons.
 * Emphasizes multi-form whole-offer validation errors that should prevent submit.
 * Provides convenient button link to open the errorful form modals.
 */
const OfferError: FC<OfferErrorProps> = ({ trip }) => {
  const dispatch = useDispatch();
  const { errors } = useOfferErrors(trip);

  return (
    <CTAError>
      {'Please fix '}
      {(errors.pickupTime || errors.returnTime) && (
        <>
          <UnstyledButton onClick={() => dispatch(open(FORMS.TIME))}>
            {/* Only one will ever be true */}
            {errors.pickupTime && 'depart time'}
            {errors.returnTime && 'return time'}
          </UnstyledButton>
          <TimeModal trip={trip} />
        </>
      )}
      {!errors.captain && '.'}
      {errors.captain && (errors.pickupTime || errors.returnTime) && ' and '}
      {errors.captain && (
        <>
          <UnstyledButton onClick={() => dispatch(open(FORMS.CAPTAIN))}>
            captain charter type.
          </UnstyledButton>
          <CaptainModal
            modalName={FORMS.CAPTAIN}
            trip={trip}
          />
        </>
      )}
    </CTAError>
  );
};

export default OfferError;
